export const LABOR_PAY_PAGE_SIZES = [5, 10, 25] as const;
export const LABOR_PAY_DEFAULT_PAGE_SIZE = 10;
